import { OutputLanguagesType } from 'components/DefaultSettings/types';

export const filterLanguagesByCountry = (
    targetCountry: string,
    languages: OutputLanguagesType[],
    selectedLanguage: string,
) => {
    return languages
        .filter((language) => language.name.includes(targetCountry))
        .sort((a, b) => {
            if (a.language_code === selectedLanguage) {
                return -1;
            }
            if (b.language_code === selectedLanguage) {
                return 1;
            }
            return 0;
        })
        .map((language) => ({
            language_code: language.language_code,
            checked: language.language_code === selectedLanguage,
            language_name: language.language_name,
            id: language.id,
            country: targetCountry,
        }));
};

export const formatLanguages = (
    languages: OutputLanguagesType[],
    savedLanguagesCodes: string[],
) => {
    return languages.map((language) => ({
        language_code: language.language_code,
        checked: savedLanguagesCodes.includes(language.language_code),
        language_name: language.language_name,
        id: language.id,
        country: language.country,
    }));
};
